module.exports = __webpack_public_path__ + "img/real4.e3183bae.png";